"use strict";

exports.__esModule = true;
exports.ScheduleListScreen = ScheduleListScreen;
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
var _react = _interopRequireDefault(require("react"));
var _App = require("../../App");
var _Auth = require("../../Auth");
var _Core = require("../../Core");
var _ScheduleList = require("../Schedule/ScheduleList");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ScheduleListScreen() {
  var _React$useContext = _react["default"].useContext(_Core.TranslatorContext),
    translate = _React$useContext.translate;
  return /*#__PURE__*/_react["default"].createElement(_Core.Screen, {
    title: translate("ScheduleListScreen.title", "Schedules"),
    "data-testid": "ScheduleListScreen"
  }, /*#__PURE__*/_react["default"].createElement(_App.AppNavbar, {
    title: translate("ScheduleListScreen.navbar.title", "Schedules")
  }), /*#__PURE__*/_react["default"].createElement(_Core.Toolbar, null, /*#__PURE__*/_react["default"].createElement(_Auth.AccessCheck, {
    permission: "EDIT_CALENDAR"
  }, function (_ref) {
    var canEdit = _ref.isAllowed;
    return /*#__PURE__*/_react["default"].createElement(_core.ButtonGroup, {
      style: {
        marginLeft: "auto"
      }
    }, canEdit && /*#__PURE__*/_react["default"].createElement(_Core.LinkButton, {
      icon: _icons.IconNames.ADD,
      to: "/calendar/create-schedule",
      text: translate("ScheduleListScreen.createScheduleButton.text", "Create Schedule")
    }), canEdit && /*#__PURE__*/_react["default"].createElement(_Core.LinkButton, {
      icon: _icons.IconNames.SETTINGS,
      to: "/calendar/settings",
      text: translate("ScheduleListScreen.settingsButton.text", "Calendar Settings")
    }));
  })), /*#__PURE__*/_react["default"].createElement(_ScheduleList.ScheduleList, null));
}